import { useEffect, useState } from 'react';

// Returns false until `delayMs` has elapsed since mount, then true.
//
// Donut/pie charts in this app use a hover-dim pattern: a `hovered` state
// flips Cell fillOpacity to fade non-hovered slices. Recharts treats any
// child-prop change as "data changed" and restarts/cancels its entry
// animation, so when the user's cursor happens to be over the chart while
// it mounts (very common on a refresh-without-mouse-move), `onMouseEnter`
// fires immediately and the swoop-in animation freezes mid-sweep.
//
// Gating `setHovered` behind this hook lets the entry animation finish
// before hover dimming becomes responsive. Default 1500ms covers our
// 1000ms Pie entry animation plus a 500ms margin before hovers re-arm.
export function useChartReady(delayMs = 1500): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);
  return ready;
}
